import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";

import { environment } from "../../../environments/environment";
import { IIncentive } from "projects/lib-ui/src/shared/interfaces/incentive";
import { IResponse } from "projects/lib-ui/src/shared/interfaces/response";
import { INCENTIVE_DEFAULT } from "projects/lib-ui/src/shared/constants/incentive-default.const";

@Injectable({
  providedIn: 'root'
})
export class IncentiveService {
  private readonly URI_API = environment.URLAPI;

  private readonly httpclient = inject(HttpClient);

  getBranchById(id: string): Observable<IIncentive | null> {
    return this.httpclient.get<IResponse<IIncentive> | null>(
      `${this.URI_API}Incentive/${id}`
    ).pipe(
      map(response => {
        if (!response || !response.success) {
          return null;
        }

        const data = response.data ?? {} as IIncentive;
        data.noticePageImg = data.noticePageImg ?? INCENTIVE_DEFAULT;
        data.winnerPageImg = data.winnerPageImg ?? INCENTIVE_DEFAULT;
        return data;
      })
    );
  }
}
